import { COMMON } from "./common";


const PROD_ENV = {
    api: "https://api.aws.tankyou.co/v2",

    auth: {
        Client: {
            ID: "2d9fddbc-efc7-4a91-bba4-c1f4b9ec33be",
            RedirectURI: "/handle_token",
            Scope: "full"
        },
        Server: {
            URL: "https://auth.tankyou.co",
            Endpoints: {
                Authorize: "/oauth/authorize",
                Token: "/oauth/token",
                Logout: "/user/logout"
            }
        }
    },

    stripe_token: "pk_live_zJvI9uIFK8AMGZdhmIVeG75u",

    ...COMMON
};

export default PROD_ENV;



// WEBPACK FOOTER //
// ./src/Utils/configs/prod.js